import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  username: String;
  password: String;

  constructor(
  private authService:AuthService,
  private router:Router,
  private flashMessage: FlashMessagesService
  ) { }

  ngOnInit() {
       if(localStorage.getItem('id_token')){
          this.router.navigate(['/dashboard']);
       }
  }

  onLoginSubmit(){
     const user = {
          username: this.username,
          password: this.password
     }
     this.authService.authenticateUser(user)
     .subscribe(data=>{
          console.log(data);
          if(data.success){
               this.authService.storeUserData(data.token, data.user);
               this.flashMessage.show("You are now logged in",{cssClass:'alert alert-success',timeout:5000});
               this.router.navigate(['/dashboard']);
          }else{
               this.flashMessage.show(data.msg,{cssClass:'alert alert-danger',timeout:5000});
               this.router.navigate(['/login']);
          }
     });

  }

}



// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts